<div class="noa-dialog">
    <h1 class="text-center mb-4" matDialogTitle>
        {{ 'fields.version_changes' | translate }} <span *ngIf="data.version">{{ data.version }} </span> <i class="fas fa-bullhorn fa-icon"></i>
    </h1>
    <div mat-dialog-content class="text-left mb-4">
        <div class="news" *ngIf="data.news" [innerHTML]="data.news | sanitize: 'html'"></div>
    </div>
    <mat-divider class="mb-4"></mat-divider>
    <div class="actions text-center">
        <button class="noa-button-link btn-primary" (click)="dialogRef.close(true)" type="button">{{ 'actions.ok' | translate }}</button>
    </div>
</div>
